'use client';
import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import Image from 'next/image';

/**
 * SectionCommunity Component
 * Benefits section showing advantages of becoming an agent
 */
const SectionCommunity: React.FC = () => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const communityData = [
    {
      id: 1,
      title: "Partner 1",
      image: "/assets/images/komunitas/komunitas1.webp"
    },
    {
      id: 2,
      title: "Partner 2",
      image: "/assets/images/komunitas/komunitas2.webp"
    },
    {
      id: 3,
      title: "Partner 3",
      image: "/assets/images/komunitas/komunitas3.webp"
    },
    {
      id: 4,
      title: "Partner 4",
      image: "/assets/images/komunitas/komunitas4.webp"
    },
    {
      id: 5,
      title: "Partner 5",
      image: "/assets/images/komunitas/komunitas5.webp"
    },
    {
      id: 6,
      title: "Partner 6",
      image: "/assets/images/komunitas/komunitas6.webp"
    },
     {
      id: 7,
      title: "Partner 7",
      image: "/assets/images/komunitas/komunitas7.webp"
    },

  ];

  // Duplicate data for seamless loop
  const duplicatedData = [...communityData, ...communityData];

  useEffect(() => {
    if (!scrollContainerRef.current) return;

    const container = scrollContainerRef.current;
    const totalWidth = container.scrollWidth / 2;

    // Create infinite scroll animation
    const animation = gsap.to(container, {
      x: -totalWidth,
      duration: 20,
      ease: "none",
      repeat: -1,
    });

    return () => {
      animation.kill();
    };
  }, [])
  return (

      <div
        // data-aos="fade-up"
        id="main" className="font-family-open-sans relative items-center"
      >
          {/* Community Section */}

          <div className="w-full flex lg:flex-col md:flex-col flex-col-reverse gap-6 items-center ">
            <div className="text-center ">
              <p className=" font-bold md:text-[24px] text-[20px] tracking-[-0.32px] text-[#222222] mb-2">
                Komunitas Solid
              </p>
              <p className="lg:max-w-[400px] md:max-w-[600px] w-full lg:text-[16px] md:font-[14px] text-[13px] leading-7 tracking-[0.16px] text-[#666666] m-0 px-6">
                Bergabung dengan komunitas partner yang saling mendukung dan berbagi tips
              </p>
            </div>

            {/* Community Image Banner */}
            <div className="w-full lg:h-[500px] md:h-[500px] sm:h-[350px] h-[200px] relative flex items-center justify-center overflow-hidden shadow-md">
              <div className="bg-[#141414]  w-full h-full absolute overflow-hidden  flex items-center ">
                <div
                  ref={scrollContainerRef}
                  className="flex gap-4 items-center"
                >
                  {duplicatedData.map((item, index) => (
                    <div
                      key={`${item.id}-${index}`}
                      className='overflow-hidden flex-shrink-0 rounded-2xl  flex items-center justify-center'
                    >
                      <Image
                        width={293}
                        height={293}
                        src={item.image}
                        alt={item.title}
                        className='md:h-[293px] md:w-[293px] h-[164px] w-[164px] object-cover'
                        loading="lazy"
                        sizes="(max-width: 768px) 164px, 293px"
                        quality={85}
                        />

                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

      </div>
     );
};

export default SectionCommunity;
